/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Timeslot object
 * @export
 * @interface TimeslotRequest
 */
export interface TimeslotRequest {
    /**
     * Unique identifier of the timeslot
     * @type {string}
     * @memberof TimeslotRequest
     */
    timeslotId?: string;
    /**
     * start time of slot
     * @type {string}
     * @memberof TimeslotRequest
     */
    start?: string;
    /**
     * end time of slot
     * @type {string}
     * @memberof TimeslotRequest
     */
    end?: string;
}

/**
 * Check if a given object implements the TimeslotRequest interface.
 */
export function instanceOfTimeslotRequest(value: object): value is TimeslotRequest {
    return true;
}

export function TimeslotRequestFromJSON(json: any): TimeslotRequest {
    return TimeslotRequestFromJSONTyped(json, false);
}

export function TimeslotRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeslotRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'timeslotId': json['timeslotId'] == null ? undefined : json['timeslotId'],
        'start': json['start'] == null ? undefined : json['start'],
        'end': json['end'] == null ? undefined : json['end'],
    };
}

export function TimeslotRequestToJSON(json: any): TimeslotRequest {
    return TimeslotRequestToJSONTyped(json, false);
}

export function TimeslotRequestToJSONTyped(value?: TimeslotRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timeslotId': value['timeslotId'],
        'start': value['start'],
        'end': value['end'],
    };
}

